import { Sidebar, Menu, MenuItem, useProSidebar } from 'react-pro-sidebar';
import { BrowserRouter, Routes, Route, NavLink, Link } from "react-router-dom"
import { useState, useEffect } from 'react'
import Main from './Main';
import { BsArrowRight, BsArrowLeft, BsBuilding, BsInputCursorText, BsBarChart, BsFileSpreadsheet, BsJournalBookmark } from 'react-icons/bs';
import { BiNetworkChart } from 'react-icons/bi';
import { TbNotes } from 'react-icons/tb';

function Layout() {
    const [collapseSideBar, setCollapseSideBar] = useState(true);
    const [pageDirectedTo, setPageDirectedTo] = useState("");
    // const { toggleSidebar } = useProSidebar();

    const viewHeight = window.outerHeight * 0.9;
    const viewWidth = window.outerWidth * 0.9;

    function onMouseEnterFunction(page) {
      // console.log("here1", page)
      // setPageDirectedTo(page)
    }

    function onMouseLeaveFunction() {
      // console.log("here2")
      // setPageDirectedTo("")
    }

    return (
        <div style={{ display: 'flex', height: '100%', minHeight: '400px' }}>
          <Sidebar defaultCollapsed={collapseSideBar} backgroundColor="rgb(249, 249, 249, 1)" transitionDuration={350} collapsedWidth="65px">
            <Menu closeOnClick={true}>
                <MenuItem onClick={() => setCollapseSideBar(!collapseSideBar)}> { collapseSideBar ? <BsArrowRight /> : <BsArrowLeft /> } { pageDirectedTo }</MenuItem>
              <a href="https://www.alvarezandmarsal.com/" className="linkText" target="_blank"><MenuItem onClick={() => setCollapseSideBar(true)}> { collapseSideBar ? <div><BsBuilding /><div style={{fontSize: '10px'}}>A&M</div></div> : <div><BsBuilding /> Alvarez and Marsal</div> }</MenuItem></a>
              <NavLink to="summary" className="linkText"><MenuItem onClick={() => setCollapseSideBar(true)}> { collapseSideBar ? <div><BsJournalBookmark /><div style={{fontSize: '10px'}}>SUM</div></div> : <div><BsJournalBookmark /> Summary</div> }</MenuItem></NavLink>
              <NavLink to="inputs" className="linkText"><MenuItem onClick={() => setCollapseSideBar(true)}> { collapseSideBar ? <div><BsInputCursorText /><div style={{fontSize: '12px'}}>INP</div></div> : <div><BsInputCursorText /> Inputs</div> }</MenuItem></NavLink>
              <NavLink to="attribute-reduction" className="linkText"><MenuItem onClick={() => setCollapseSideBar(true)}> { collapseSideBar ? <div><BsBarChart /><div style={{fontSize: '12px'}}>AR</div></div> : <div><BsBarChart /> Attribute Reduction</div> }</MenuItem></NavLink>
              <NavLink to="balance-sheet" className="linkText"><MenuItem onClick={() => setCollapseSideBar(true)}> { collapseSideBar ? <div><BsFileSpreadsheet /><div style={{fontSize: '12px'}}>BS</div></div> : <div><BsFileSpreadsheet /> Balance Sheet</div> }</MenuItem></NavLink>
              <NavLink to="legal-org-chart" className="linkText"><MenuItem onClick={() => setCollapseSideBar(true)}> { collapseSideBar ? <div><BiNetworkChart /><div style={{fontSize: '10px'}}>ORG</div></div> : <div><BiNetworkChart /> Legal Org Chart</div> }</MenuItem></NavLink>
              <NavLink to="notes" className="linkText" onMouseEnter={onMouseEnterFunction("Notes")} onMouseLeave={onMouseLeaveFunction}><MenuItem onClick={() => setCollapseSideBar(true)}> { collapseSideBar ? <div><TbNotes /><div style={{fontSize: '10px'}}>NTS</div></div> : <div><TbNotes /> Notes</div> }</MenuItem></NavLink>
            </Menu>
          </Sidebar>
          <main style={{ padding: 10, height: viewHeight, width: viewWidth }} >
              {/* <button className="sb-button" onClick={() => setCollapseSideBar(!collapseSideBar)}>Menu</button> */}
              <Main></Main>
          </main>
        </div>
    );

    // return (
    //   <div style={{ display: 'flex', height: '100%', minHeight: '400px' }}>
    //     <Sidebar breakPoint="always" backgroundColor="rgb(249, 249, 249, 1)" transitionDuration={350}>
    //       <Menu closeOnClick={true}>
    //         <a href="https://www.alvarezandmarsal.com/" target="_blank"><MenuItem onClick={() => toggleSidebar()}> Alvarez and Marsal</MenuItem></a>
    //         <NavLink to="summary"><MenuItem onClick={() => toggleSidebar()}> Summary</MenuItem></NavLink>
    //         <NavLink to="inputs"><MenuItem onClick={() => toggleSidebar()}> Inputs</MenuItem></NavLink>
    //         <NavLink to="attribute-reduction"><MenuItem onClick={() => toggleSidebar()}> Attribute Reduction</MenuItem></NavLink>
    //         <NavLink to="balance-sheet"><MenuItem onClick={() => toggleSidebar()}> Balance Sheet</MenuItem></NavLink>
    //         <NavLink to="legal-org-chart"><MenuItem onClick={() => toggleSidebar()}> Legal Org Chard</MenuItem></NavLink>
    //         <NavLink to="notes"><MenuItem onClick={() => toggleSidebar()}> Notes</MenuItem></NavLink>
    //       </Menu>
    //     </Sidebar>
    //     <main style={{ padding: 10, height: viewHeight, width: viewWidth }}>
    //       <div>
    //         <button className="sb-button" onClick={() => toggleSidebar()}>Menu</button>
    //         <Main></Main>
    //       </div>
    //     </main>
    //   </div>
    // );
}

export default Layout;